import { Injectable, EventEmitter } from '@angular/core';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/public_api';
import { SsrCookieService as CookieService } from 'ngx-cookie-service-ssr';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  readonly onCurrencyChange: EventEmitter<string> = new EventEmitter<string>();
  public actualCurrency = 'EUR';

  constructor(
    private platformInformationService: PlatformInformationService,
    private cookieService: CookieService
  ) {
    const cookie = cookieService.get('currency');
    // check if cookie exists and use it
    if (cookie) {
      // ar AND es are the only to support USD. Rewrite to EUR on all others
      // ar is the only to support CZK. Rewrite to EUR  on all others
      if (
        (cookie === 'USD' &&
          !['ar', 'es'].includes(platformInformationService.getCurrentPlatformShortcode())) ||
        (cookie === 'CZK' && platformInformationService.getCurrentPlatformShortcode() !== 'ar')
      ) {
        this.setActualCurrency('EUR');
      } else {
        this.setActualCurrency(cookie);
      }
    } else {
      // if not, get card and data by server
      if (platformInformationService.getIsBrowser()) {
        // used to get server side cookie by customerCountryCode response
        this.platformInformationService.customerCountryCode$.subscribe(() => {
          this.platformInformationService.data$.subscribe(data => {
            // check cookie again (set by customerCountryCode request) and use it
            if (cookieService.get('currency')) {
              this.setActualCurrency(cookieService.get('currency'));
              // if not, use fallback logic
            } else {
              const window = platformInformationService.getWindow();
              if (
                // fallback with best guess
                ['de-CH'].includes(window.navigator.language) &&
                data.acceptedCurrencies.includes('CHF')
              ) {
                this.setActualCurrency('CHF');
              } else if (
                ['en-US'].includes(window.navigator.language) &&
                data.acceptedCurrencies.includes('USD')
              ) {
                this.setActualCurrency('USD');
              } else if (
                ['en', 'en-GB', 'en-GB-oxendict'].includes(window.navigator.language) &&
                data.acceptedCurrencies.includes('GBP')
              ) {
                this.setActualCurrency('GBP');
              } else if (
                ['cs', 'cs-CZ'].includes(window.navigator.language) &&
                data.acceptedCurrencies.includes('CZK')
              ) {
                this.setActualCurrency('CZK');
              } else {
                this.setActualCurrency('EUR');
              }
            }
          });
        });
      } else {
        this.setActualCurrency('EUR'); // placeholder
      }
    }
  }

  getActualCurrency(): string {
    return this.actualCurrency;
  }

  /**
   * set currency to given value and emit change.
   * If browser, the information will be stored in the currency cookie as well
   * @param currency the string of the given currency 'EUR', 'USD', ...
   */
  setActualCurrency(currency: string) {
    this.actualCurrency = currency;
    // don't set cookies on server or the route won't be cached
    if (this.platformInformationService.getIsBrowser()) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1); // works even on last day of month, intelligent rollover
      this.cookieService.set('currency', currency, tomorrow, '/');
    }
    this.onCurrencyChange.emit(currency);
  }
}
